export const FLAG = {
  INCODE_SDK_FLOW: 'incode_sdk_flow',
  MANDATORY_BANK_DETAILS: 'mandatory_bank_details',
  MW_4_1_MILEAGE_REMOVAL: 'mw_4_1_mileage_removal',
  PAAS_WEB_ON_RAMP: 'paas_web_on_ramp',
} as const;

export const EVENT = {
  AGENT_SUPPORT_CONTACTED: 'agent_support_contacted',
  ENQUIRY_CREATED: 'enquiry_created',
  ENQUIRY_LOADED: 'enquiry_load',
  EXPIRED_LINK_LOAD: 'expired_link_load',
  HERO_MILEAGE_CTA_CLICKED: 'valuations_hero_mileage_cta_clicked',
  HERO_VRM_CTA_CLICKED: 'valuations_hero_vrm_cta_clicked',
  OFFER_SELECT: 'offer_select',
  PHOTO_HANDOVER_SEEN: 'photo_handover_seen',
  PROFILE_FIRST_QUESTION_ANSWERED: 'profile_first_question_answered',
  PROFILE_FIRST_QUESTION_SEEN: 'profile_first_question_seen',
  PS_ACCEPT_OFFER_CTA_CLICKED: 'ps_accept_offer_cta_clicked',
  PS_COMPLETE_SALE_CTA_CLICKED: 'ps_complete_sale_cta_clicked',
  SIGN_IN_CTA_CLICKED: 'sign_in_cta_clicked',
  SIGN_IN_LOADED: 'sign_in_load',
  SIGN_IN_SUCCESS_LOAD: 'sign_in_success_load',
  SIGN_UP_CTA_CLICKED: 'sign_up_cta_clicked',
  SIGN_UP_LOADED: 'sign_up_load',
  SIGN_UP_TOOLTIP_SHOW: 'contact_details_page_info_hover',
  SMV_MILEAGE_CTA_CLICKED: 'smv_mileage_cta_clicked',
  VALUATIONS_LOADED: 'valuations_load',
  VALUATIONS_MILEAGE_CTA_CLICKED: 'valuations_mileage_cta_clicked',
  VALUATIONS_MILEAGE_UPDATED: 'valuations_mileage_updated',
  VEHICLE_HUB_VIEW_SECTIONS: 'vehicle_hub_view_sections',
  VEHICLE_HUB_VIEW_VEHICLE_INFORMATION: 'vehicle_hub_view_vehicle_information',
} as const;

export const EXPERIMENT_DECISIONS_HEADER = 'experiment-decisions';
